import api, { ApiResponse } from "../api";
import axios, { CancelTokenSource } from "axios";
import { TerminalActivtyLogModel, TerminalSummaryModel } from "./TerminalListModel";
import { PageResponseModel } from "../common/models";

export const REQUEST_ID: {
  [key: string]: string;
} = {
  GET_REGION_SERVICE_CENTERS: "get_region_service_centers",
  GET_TERMINALS: "get_terminals",
  GET_TERMINALS_TILES: "get_terminals_tiles",
  GET_TERMINALS_ACTIVITY_LOGS: "get_terminals_activity_logs",
  GET_ORIGINAL_TERMINALS: "get_original_terminals",
  GET_ORIGINAL_COUNTS: "get_original_counts"
};

class TerminalSummaryService {
  private source: {
    [key: string]: CancelTokenSource;
  };
  private statsCancelToken: CancelTokenSource | null = null;
  private static instance: TerminalSummaryService;

  private constructor() {
    this.source = {};
  }

  public cancelRequest = (requestId: string) => {
    this.source[requestId] && this.source[requestId].cancel();
  }

  static getInstance(): TerminalSummaryService {
    if (!TerminalSummaryService.instance) {
      TerminalSummaryService.instance = new TerminalSummaryService();
    }
    return TerminalSummaryService.instance;
  }

  public getRegionsServiceCenters = async (): Promise<
    ApiResponse<[]>
  > => {
    this.source[REQUEST_ID.GET_REGION_SERVICE_CENTERS] && this.source[REQUEST_ID.GET_REGION_SERVICE_CENTERS].cancel();
    this.source[REQUEST_ID.GET_REGION_SERVICE_CENTERS] = axios.CancelToken.source();
    return await api.get("/terminals/regions", { cancelToken: this.source[REQUEST_ID.GET_REGION_SERVICE_CENTERS].token });
  };

  public getTerminalTiles = async (): Promise<
    ApiResponse<{}>
  > => {
    this.source[REQUEST_ID.GET_TERMINALS_TILES] && this.source[REQUEST_ID.GET_TERMINALS_TILES].cancel();
    this.source[REQUEST_ID.GET_TERMINALS_TILES] = axios.CancelToken.source();
    return await api.get("/terminals/summary-counts", { cancelToken: this.source[REQUEST_ID.GET_TERMINALS_TILES].token });
  };

  public getTerminalsList = async (
    page?: number,
    search?: any | "",
    region?: any | "",
    status?: any | "",
    terminalType?: string | null,
    physicalLocation?: boolean | null
  ): Promise<ApiResponse<PageResponseModel<TerminalSummaryModel>>> => {
    const params = new URLSearchParams();

    if (page !== undefined) params.append("page", page.toString());
    if (search) params.append("search", search);
    if (region) params.append("region", region);
    if (status) params.append("status", status);
    if (terminalType) params.append("terminalType", terminalType);
    if (physicalLocation) params.append("physicalLocation", physicalLocation.toString());

    this.cancelRequest(REQUEST_ID.GET_TERMINALS);
    this.source[REQUEST_ID.GET_TERMINALS] = axios.CancelToken.source();
    return await api.get("/terminals", { params, cancelToken: this.source[REQUEST_ID.GET_TERMINALS].token });
  };

  //terminal activity log list
  public getTerminalActivityLogList = async (
    page?: number,
    search?: any,
    action?: any,
    dateFrom?: any,
    dateTo?: any,
  ): Promise<ApiResponse<PageResponseModel<TerminalActivtyLogModel>>> => {
    const params = new URLSearchParams();

    if (page) params.append("page", page.toString());
    if (search) params.append("search", search);
    if (action) params.append("action", action);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);

    this.cancelRequest(REQUEST_ID.GET_TERMINALS_ACTIVITY_LOGS);
    this.source[REQUEST_ID.GET_TERMINALS_ACTIVITY_LOGS] = axios.CancelToken.source();
    return await api.get("/terminals/activity-log/all", { params, cancelToken: this.source[REQUEST_ID.GET_TERMINALS_ACTIVITY_LOGS].token });
  };

  public getOriginalTerminals = async (page?: number,
    search?: any | "",
    region?: any | "",
    status?: any | "", 
    terminalType?: any | ""): Promise<ApiResponse<PageResponseModel<TerminalSummaryModel>>> => {
    const params = new URLSearchParams();

    if (page !== undefined) params.append("page", page.toString());
    if (search) params.append("search", search);
    if (region) params.append("region", region);
    if (status) params.append("status", status);
    if (terminalType) params.append("terminalType", terminalType);

    this.cancelRequest(REQUEST_ID.GET_ORIGINAL_TERMINALS);
    this.source[REQUEST_ID.GET_ORIGINAL_TERMINALS] = axios.CancelToken.source();
    return await api.get("/terminals/originals", { params, cancelToken: this.source[REQUEST_ID.GET_ORIGINAL_TERMINALS].token });
  };

  public getOriginalCounts = async (status?: string | ""): Promise<ApiResponse<any>> => {
    const params = new URLSearchParams();
    this.cancelRequest(REQUEST_ID.GET_ORIGINAL_COUNTS);
    this.source[REQUEST_ID.GET_ORIGINAL_COUNTS] = axios.CancelToken.source();
    if (status) params.append("status", status);
    return await api.get("/terminals/original-counts", { params, cancelToken: this.source[REQUEST_ID.GET_ORIGINAL_COUNTS].token });
  }
}


export default TerminalSummaryService;
